// Bootstrap
import 'bootstrap';

// Swiper
import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Seus estilos SCSS
import '../scss/main.scss';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Importar imagens (isso fará o webpack processar e converter para webp)
function importAll(r) {
  return r.keys().map(r);
}

const swiperConfig = {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
};

// Isso processa todas as imagens e gera os WebP
const images = importAll(require.context('../images/', true, /\.(png|jpe?g|gif)$/));

// Inicializar Swiper (exemplo)
document.addEventListener('DOMContentLoaded', () => {



  const menuButton = document.getElementById('mobileMenuButton');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const menuLinks = document.querySelectorAll('.mobile-menu-item');
    
    let scrollPosition = 0;
    
    // Função para abrir menu
    function openMenu() {
        scrollPosition = window.pageYOffset;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
        mobileMenuOverlay.classList.add('active');
    }
    
    // Função para fechar menu
    function closeMenu() {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');
        window.scrollTo(0, scrollPosition);
        mobileMenuOverlay.classList.remove('active');
    }
    
    // Abrir menu
    menuButton.addEventListener('click', function(e) {
        e.preventDefault();
        openMenu();
    });
    
    // Fechar menu ao clicar no X
    mobileMenuClose.addEventListener('click', closeMenu);
    
    // Fechar menu ao clicar em um link
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });
    
    // Fechar ao clicar fora do conteúdo (opcional)
    mobileMenuOverlay.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
            closeMenu();
        }
    });





  let pillsSwiper;

  function initPillsSwiper() {
    const isMobile = window.innerWidth < 992;

    if (isMobile && !pillsSwiper) {
      pillsSwiper = new Swiper('.gallery-pills-wrapper', {
        slidesPerView: 'auto',
        freeMode: true,
      });
    }

    if (!isMobile && pillsSwiper) {
      pillsSwiper.destroy(true, true);
      pillsSwiper = null;
    }
  }

  window.addEventListener('load', initPillsSwiper);
  window.addEventListener('resize', initPillsSwiper);
  
  const aboutSwiper = new Swiper('.aboutSwiper', {
    modules: [Pagination, Autoplay], // adicionar Autoplay aqui
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true, // adicione loop para rodar infinito
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
    
});




  Fancybox.bind("[data-fancybox]", {
    // Opções personalizadas
    Toolbar: {
      display: {
        left: [],
        middle: [],
        right: ["close"]
      }
    },
    Image: {
      zoom: true,
      click: "close"
    },
    animated: true
  });

  const swiperImagens = new Swiper('#swiperImagens', {
    ...swiperConfig,
    navigation: {
      nextEl: '#swiperImagens .swiper-button-next',
      prevEl: '#swiperImagens .swiper-button-prev',
    },
  });

  const swiperDecorado = new Swiper('#swiperDecorado', {
    ...swiperConfig,
    navigation: {
      nextEl: '#swiperDecorado .swiper-button-next',
      prevEl: '#swiperDecorado .swiper-button-prev',
    },
  });

  const swiperLazer = new Swiper('#swiperLazer', {
    ...swiperConfig,
    navigation: {
      nextEl: '#swiperLazer .swiper-button-next',
      prevEl: '#swiperLazer .swiper-button-prev',
    },
  });

  const swiperPlanta = new Swiper('#swiperPlanta', {
    ...swiperConfig,
    navigation: {
      nextEl: '#swiperPlanta .swiper-button-next',
      prevEl: '#swiperPlanta .swiper-button-prev',
    },
  });

  const swiperVideos = new Swiper('#swiperVideos', {
    ...swiperConfig,
    navigation: {
      nextEl: '#swiperVideos .swiper-button-next',
      prevEl: '#swiperVideos .swiper-button-prev',
    },
  });
  const attendance = document.querySelector('.attendance');
    let lastScrollTop = 0;
    
    // Função para verificar se é mobile
    function isMobile() {
        return window.innerWidth < 768; // md breakpoint do Bootstrap
    }
    
    // Função para controlar a visibilidade da barra
    function handleAttendanceBar() {
        if (!isMobile()) {
            // Desktop: sempre visível
            attendance.classList.add('visible');
            return;
        }
        
        // Mobile: mostrar após scroll
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 100) { // Aparece após 100px de scroll
            attendance.classList.add('visible');
        } else {
            attendance.classList.remove('visible');
        }
        
        lastScrollTop = scrollTop;
    }
    
    // Executa na carga da página
    handleAttendanceBar();
    
    // Executa no scroll
    window.addEventListener('scroll', handleAttendanceBar);
    
    // Executa no resize (caso usuário mude orientação ou tamanho da janela)
    window.addEventListener('resize', handleAttendanceBar);


    const smartLinks = document.querySelectorAll('.smart-scroll-link');
    
    smartLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            
            const isMobile = window.innerWidth < 768;
            const targetSelector = isMobile 
                ? this.dataset.mobileTarget 
                : this.dataset.desktopTarget;
            
            const targetElement = document.querySelector(targetSelector);
            
            if (targetElement) {
                targetElement.scrollIntoView({ 
                    behavior: 'smooth',
                    block: 'start'
                });
                
                // Adiciona offset se necessário (ex: header fixo)
                // window.scrollBy(0, -80);
            }
        });
    });

const lazerThumbs = document.querySelectorAll('.lazer-thumb');
    
    lazerThumbs.forEach(thumb => {
        thumb.addEventListener('click', function(e) {
            e.preventDefault();
            
            const galleryIndex = this.dataset.galleryIndex;
            const galleryItems = document.querySelectorAll('a[data-fancybox="gallery-lazer"]');
            
            if (galleryItems[galleryIndex]) {
                galleryItems[galleryIndex].click();
            }
        });
    });


    const forms = document.querySelectorAll('.needs-validation');
    
    forms.forEach(function(form) {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            event.stopPropagation();
            
            // Validação customizada do telefone
            const telefoneInput = form.querySelector('input[type="tel"]');
            if (telefoneInput) {
                const telefoneValue = telefoneInput.value.replace(/\D/g, '');
                
                if (telefoneValue.length !== 10 && telefoneValue.length !== 11) {
                    telefoneInput.setCustomValidity('Telefone deve ter 10 ou 11 dígitos');
                } else {
                    telefoneInput.setCustomValidity('');
                }
            }
            
            if (form.checkValidity()) {
              const formData = new FormData(form);
              
              
              fetch('https://httpbin.org/post', {  // endpoint 
                  method: 'POST',
                  body: formData
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Resposta do servidor:', data);
                    
                    // Mostra sucesso
                    form.classList.add('d-none');
                    const successMessage = form.nextElementSibling;
                    if (successMessage && successMessage.classList.contains('success')) {
                        successMessage.classList.remove('d-none');
                    }
                    form.reset();
                    form.classList.remove('was-validated');
                })
                .catch(error => {
                    console.error('Erro:', error);
                });
            }

            
            form.classList.add('was-validated');
        });
    });
    
    // Máscara de telefone para TODOS os inputs de telefone
    const telefoneInputs = document.querySelectorAll('input[type="tel"]');
    telefoneInputs.forEach(function(telefoneInput) {
        telefoneInput.addEventListener('input', function(e) {
            let value = e.target.value.replace(/\D/g, '');
            
            if (value.length > 11) {
                value = value.slice(0, 11);
            }
            
            if (value.length <= 10) {
                value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
                value = value.replace(/(\d)(\d{4})$/, '$1-$2');
            } else {
                value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
                value = value.replace(/(\d)(\d{4})$/, '$1-$2');
            }
            
            e.target.value = value;
            telefoneInput.setCustomValidity('');
        });
    });
    
    // Máscara de telefone para TODOS os inputs de telefone
    


    // Desktop
    const locationSection = document.getElementById('localizacao');
    const mapLinks = locationSection ? locationSection.querySelectorAll('.link a') : [];
    
    if (locationSection) {
        locationSection.addEventListener('click', function(e) {
            // Não ativa se clicar nos links do Google Maps ou Waze
            let isLinkClick = false;
            mapLinks.forEach(link => {
                if (link.contains(e.target)) {
                    isLinkClick = true;
                }
            });
            
            if (!isLinkClick && !this.classList.contains('map-active')) {
                this.classList.add('map-active');
            }
        });
    }
    
    // Mobile
    const locationMobile = document.getElementById('locationMobile');
    
    if (locationMobile) {
        locationMobile.addEventListener('click', function() {
            if (!this.classList.contains('map-active')) {
                this.classList.add('map-active');
            }
        });
    }

});
